import { SocialMediaSharer } from '#components/SocialMediaSharer';

import styles from './ArticleModuleSocialMediaSharer.module.scss';
import type { ArticleModuleSocialMediaSharerFragment } from './__generated__/ArticleModuleSocialMediaSharer.generated';

type Props = {
	article: ArticleModuleSocialMediaSharerFragment;
};

export function ArticleModuleSocialMediaSharer({ article }: Props) {
	if (!article.shareUrl || !article.title) {
		return null;
	}

	const commentId = article.allowComments ? article.rowId : undefined;

	return (
		<section className={styles.wrapper}>
			<SocialMediaSharer direction="horizontal" commentId={commentId} headline={article.title} url={article.shareUrl} />
		</section>
	);
}
